import React, { Suspense, lazy, useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import useScrollAnimation from './hooks/useScrollAnimation';
import './App.css';

const TrustStrip        = lazy(() => import('./components/TrustStrip'));
const ProblemSection    = lazy(() => import('./components/ProblemSection'));
const Services          = lazy(() => import('./components/Services'));
const Portfolio         = lazy(() => import('./components/Portfolio'));
const Process           = lazy(() => import('./components/Process'));
const TechStack         = lazy(() => import('./components/TechStack'));
const WhySection        = lazy(() => import('./components/WhySection'));
const EngagementSection = lazy(() => import('./components/EngagementSection'));
const FAQSection        = lazy(() => import('./components/FAQSection'));
const CTASection        = lazy(() => import('./components/CTASection'));
const Footer            = lazy(() => import('./components/Footer'));
const QuoteModal        = lazy(() => import('./components/QuoteModal'));

const LoadingSpinner = () => (
  <div className="loading-spinner">
    <div className="spinner"></div>
  </div>
);

const App: React.FC = () => {
  useScrollAnimation();
  const [isQuoteOpen, setIsQuoteOpen] = useState(false);
  const [preselectedService, setPreselectedService] = useState('');

  const openQuote = (service: string = '') => {
    setPreselectedService(service);
    setIsQuoteOpen(true);
    document.body.classList.add('modal-open');
  };

  const closeQuote = () => {
    setIsQuoteOpen(false);
    document.body.classList.remove('modal-open');
  };

  useEffect(() => {
    return () => { document.body.classList.remove('modal-open'); };
  }, []);

  return (
    <div className="App">
      <Header onRequestQuote={() => openQuote()} />
      <main>
        <Hero onRequestQuote={() => openQuote()} />
        <Suspense fallback={<LoadingSpinner />}>
          <TrustStrip />
          <ProblemSection />
          <Services onRequestQuote={openQuote} />
          <Portfolio />
          <Process />
          <TechStack />
          <WhySection />
          <EngagementSection onRequestQuote={openQuote} />
          <FAQSection />
          <CTASection onRequestQuote={() => openQuote()} />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer onRequestQuote={openQuote} />
      </Suspense>
      {isQuoteOpen && (
        <Suspense fallback={null}>
          <QuoteModal
            onClose={closeQuote}
            preselectedService={preselectedService}
          />
        </Suspense>
      )}
    </div>
  );
};

export default App;
